import(/* webpackMode: "eager" */ "/vercel/path0/app/simple-scheduler/api-embed/page.tsx")